import React from 'react';
import cn from '@/utils/cn';

interface SPASectionHeadingProps {
  className?: string;
  /** A legacy full-reload destination, shown as an "Open <title> ↗" link beside the heading. */
  href?: string;
  /** Quiet text on the right (a count, a sort note). Ignored when href is set. */
  meta?: React.ReactNode;
  title: string;
}

// The section heading row used by the reason lists: uppercase eyebrow left, quiet meta right.
const SPASectionHeading = ({
  className, href, meta, title,
}: SPASectionHeadingProps) => (
  <div className={cn('tw-mb-2 tw-flex tw-items-baseline tw-justify-between tw-gap-3', className)}>
    <h3 className="tw-m-0 tw-text-sm tw-font-semibold tw-uppercase tw-tracking-wider tw-text-spa-primary">
      {title}
    </h3>
    {href && (
      <a
        className={cn(
          'tw-shrink-0 tw-text-xs tw-font-semibold tw-text-spa-accent-text tw-no-underline',
          'hover:tw-text-spa-accent-text-hover hover:tw-underline',
        )}
        href={href}
      >
        Open {title}
        <span aria-hidden="true" className="tw-ml-0.5">↗</span>
      </a>
    )}
    {!href && meta && (
      <span className="tw-whitespace-nowrap tw-text-xs tw-text-spa-tertiary">{meta}</span>
    )}
  </div>
);

export default SPASectionHeading;
